import React from "react";

import { AdminSection, Col, Input, InputNumber, Option, Row, Select } from "components";

export const MethodContinuationTab = ({ continuation, toggleContinuation, updateContinuation }) => (
  <>
    <AdminSection
      headline="Specify method continuation options"
      description={<>Select whether this method is once off or expected to continue indefinitely.</>}
    />
    <Row>
      <Col sm={24} md={12}>
        <Select
          name="continuation"
          label="Select continuation option"
          rules={[{ required: true }]}
          initialValue={continuation && !!continuation}
          style={{ width: "100%" }}
          onChange={(v) => toggleContinuation(v)}
        >
          <Option value={false}>Once-off method</Option>
          <Option value={true}>Continuous method</Option>
        </Select>
      </Col>
    </Row>
    {continuation && (
      <>
        <Row>
          <Col sm={12} md={12}>
            <InputNumber
              name={"continuationFrequency"}
              label={"Weeks since completion of method"}
              rules={[{ required: true, type: "number" }]}
              className="no-suffix"
              initialValue={continuation && continuation.frequency ? parseInt(continuation.frequency) : undefined}
              onBlur={(v) => updateContinuation("frequency", v.currentTarget.value)}
              min={0}
              max={104}
              step={1}
            />
          </Col>
          <Col sm={4} md={4}>
            <InputNumber
              name="cf"
              label="Cf"
              rules={[{ required: true, type: "number" }]}
              initialValue={continuation && continuation.cf ? parseFloat(continuation.cf) : undefined}
              className="no-suffix"
              onChange={(v) => updateContinuation("cf", v)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              name={"continuationTaskTitle"}
              label={"Task title"}
              rules={[{ required: true }]}
              initialValue={continuation ? continuation.title : undefined}
              onChange={(v) => updateContinuation("title", v.target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              name={"continuationTaskDescription"}
              label={"Task description"}
              rules={[{ required: true }]}
              initialValue={continuation ? continuation.description : undefined}
              onChange={(v) => updateContinuation("description", v.target.value)}
            />
          </Col>
        </Row>
      </>
    )}
  </>
);
